import Link from 'next/link'
import { Button } from '../ui/button'

const CustomFeatureLinkOrButton = ({
  as = 'button',
  href,
  children,
  ...props
}: any) => {
  if (as === 'link' && href) {
    const isExternal = href.startsWith('http')
    return (
      <Link href={href} {...props} {...(isExternal ? { target: '_blank' } : {})}>
        {children}
      </Link>
    )
  }

  return <Button {...props}>{children}</Button>
}

export default CustomFeatureLinkOrButton
